var React = require('react');

function Sun60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 30.999H47A1 1 0 1 1 47 29h12a1 1 0 1 1 0 1.999zM44.707 16.207a.996.996 0 0 1-.707.292 1 1 0 0 1-.707-1.707l8-8a1 1 0 0 1 1.414 1.414l-8 8.001zM30 40.498c-6.065 0-11-4.935-11-10.998 0-6.066 4.935-11.001 11-11.001S41 23.434 41 29.5c0 6.063-4.935 10.998-11 10.998zM30 20.5c-4.963 0-9 4.036-9 9 0 4.961 4.037 8.999 9 8.999s9-4.038 9-8.999c0-4.964-4.037-9-9-9zm0-7.5a1 1 0 0 1-1-1.001v-11a1 1 0 1 1 2 0v11A1 1 0 0 1 30 13zM8.707 52.207a.996.996 0 0 1-.707.292 1 1 0 0 1-.707-1.707l8-8a.999.999 0 1 1 1.414 1.414l-8 8.001zM16 16.499a.996.996 0 0 1-.707-.292l-8-8.001a.999.999 0 1 1 1.414-1.414l8 8A1 1 0 0 1 16 16.499zm-2 13.5a1 1 0 0 1-1 1H1A1 1 0 1 1 1 29h12c.553 0 1 .446 1 .999zm16 16a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-12a1 1 0 0 1 1-1zm14.707-3.207l8 8a1 1 0 1 1-1.414 1.415l-8-8.001a.999.999 0 1 1 1.414-1.414z","key":1})]);
}

Sun60px.displayName = "Sun60px";

Sun60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};

module.exports = Sun60px;

Sun60px.default = Sun60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/sun-60px.svg
// module id = 1218
// module chunks = 0